import { render } from "./B2bFiltersAuditoriaAcciones.vue?vue&type=template&id=f4536554&scoped=true&lang=pug"
import script from "./B2bFiltersAuditoriaAcciones.vue?vue&type=script&lang=js"
export * from "./B2bFiltersAuditoriaAcciones.vue?vue&type=script&lang=js"

import "./B2bFiltersAuditoriaAcciones.vue?vue&type=style&index=0&id=f4536554&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4536554"]])

export default __exports__